import types from "rdx/modules/enterpriseLeads/types";
import createAction from "rdx/utils/createAction";

export default {
  getEnterpriseLeads: (payload) => createAction(types.GET_ENTERPRISE_LEADS_REQUEST, payload),
  setEnterpriseLeads: (payload) => createAction(types.SET_ENTERPRISE_LEADS, payload),
  // INSERTION_PT (for script, do not remove)
};
